import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { Link } from "react-router-dom";
import { searchProduct } from "../actions/storeActions";

const SearchBar = ({ numberPerPage, totalArticles, paginate, currentPage }) => {
  const [search, setSearch] = useState("");
  const [result, setResult] = useState([]);
  const handleChange = (e) => {
    setSearch(e.target.value);
  };
  useEffect(() => {
    (async function getData() {
      const data = await searchProduct({ data: { search: search } });

      setResult(data);
    })();
  }, [search]);
  return (
    <>
      <div className="search_container">
        <div className="search">
          <input
            type="text"
            name=""
            id=""
            value={search}
            onChange={(e) => handleChange(e)}
          />
          <button>
            <AiOutlineSearch />{" "}
          </button>
        </div>
        <div className="search_result_container">
          {result?.length > 0
            ? result?.map((data) => {
                const { name, _id } = data;

                return (
                  <a href={`/product/${_id}`} onClick={() => setSearch("")}>
                    <p className="each_result" key={_id}>
                      {name}
                    </p>
                  </a>
                );
              })
            : result?.msg && <p className="each_result">{result?.msg}</p>}
        </div>
      </div>
    </>
  );
};

export default SearchBar;
